import React, { useState } from 'react';
import { FiCheckCircle, FiInfo, FiPlusSquare, FiTarget } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { All, CreateNewProject, Doing, Done } from '../../../Constant';
import useShowClass from '../../../Utils/Hooks/useAnimateClass';
import AllProject from './AllProject';

const ProjectTab = () => {
  const [active, setActive] = useState('1');
  const [show, setShow] = useShowClass('show', 100);
  const activeHandler = (tab) => {
    setActive(tab);
    setShow('');
  };
  return (
    <>
      <Col md='12' className='project-list'>
        <Card>
          <Row>
            <Col md='6' className='p-0 d-flex'>
              <Nav tabs className='nav-tabs border-tab'>
                <NavItem>
                  <NavLink className={active === '1' ? 'active' : ''} onClick={() => activeHandler('1')}>
                    <FiTarget />
                    {All}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={active === '2' ? 'active' : ''} onClick={() => activeHandler('2')}>
                    <FiInfo />
                    {Doing}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={active === '3' ? 'active' : ''} onClick={() => activeHandler('3')}>
                    <FiCheckCircle />
                    {Done}
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md='6' className='p-0'>
              <div className='form-group mb-0 me-0' />
              <Link className='btn btn-primary' to={`${process.env.PUBLIC_URL}/project/create-project`}>
                <FiPlusSquare className='me-1' />
                {CreateNewProject}
              </Link>
            </Col>
          </Row>
        </Card>
      </Col>
      <Col sm='12'>
        <Card>
          <CardBody>
            <TabContent activeTab={active}>
              <TabPane className={`fade ${active === '1' && show}`} tabId='1'>
                <AllProject />
              </TabPane>
              <TabPane className={`fade ${active === '2' && show}`} tabId='2'>
                <AllProject filterProject='Doing' />
              </TabPane>
              <TabPane className={`fade ${active === '3' && show}`} tabId='3'>
                <AllProject filterProject='Done' />
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default ProjectTab;
